// test838
(838 && 0);
